import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export async function readFirstWorksheetAsJson(
  file: File
): Promise<Record<string, unknown>[]> {
  const workbook = new ExcelJS.Workbook();
  const data = await file.arrayBuffer();
  await workbook.xlsx.load(data);

  const worksheet = workbook.worksheets[0];
  if (!worksheet) {
    return [];
  }

  const rows: unknown[][] = [];
  worksheet.eachRow({ includeEmpty: false }, (row) => {
    const values = (row.values as unknown[]).slice(1);
    rows.push(values);
  });

  if (rows.length === 0) {
    return [];
  }

  const headers = rows[0].map((cell) => `${cell ?? ""}`.trim());
  return rows
    .slice(1)
    .filter((row) =>
      row.some((cell) => `${cell ?? ""}`.trim().length > 0)
    )
    .map((row) => {
      const record: Record<string, unknown> = {};
      headers.forEach((header, index) => {
        if (header) {
          record[header] = row[index];
        }
      });
      return record;
    });
}

export async function downloadWorkbook(params: {
  workSheets: {
    workSheetData: unknown[][];
    worksheetName: string;
  }[];
  fileName: string;
}) {
  const workbook = new ExcelJS.Workbook();

  params.workSheets.forEach(({ worksheetName, workSheetData }) => {
    const worksheet = workbook.addWorksheet(worksheetName);
    workSheetData.forEach((row) => {
      worksheet.addRow(row);
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const normalizedFileName = params.fileName.endsWith(".xlsx")
    ? params.fileName
    : `${params.fileName}.xlsx`;

  saveAs(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    normalizedFileName
  );
}
